import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: true,
})
export class FilterPipe<T> implements PipeTransform {
  transform(list: T[] | undefined, key: keyof T, matchValue: unknown): T[] {
    const filtered = list?.filter((item) => {
      return item[key] === matchValue;
    });
    return filtered || [];
  }
}
